<template>
  <div>
    <el-form :label-width="labelWidth" :model="form" ref="form" :rules="rules">
      <div v-for="(item, index) in form.businessSetting" :key="'b' + index">
        <el-form-item :label="item.componentName">
          <el-row>
            <el-col :span="3">
              <el-select v-model="item.componentMatchType" @change="$emit('change')">
                <el-option
                  v-for="m in item.options"
                  :key="m.value"
                  :label="m.label"
                  :value="m.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col v-if="item.componentKey === 'vid'" :span="21" style="padding-left:10px">
              <el-form-item :prop="'businessSetting.' + index + '.componentValue'" :rules="rules.componentValue">
                <el-input v-model="item.componentValue" :placeholder="item.componentPlace" clearable>
                  <el-button slot="append" class="select-btn" @click="openSelectVid(item)">快速选择</el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col v-else :span="21" style="padding-left:10px">
              <template v-if="item.componentType === 'text'">
                <el-form-item
                  :prop="'businessSetting.' + index + '.componentValue'"
                  :rules="rules.componentValue"
                >
                  <el-input
                    v-model="item.componentValue"
                    :placeholder="item.componentPlace"
                    @change="$emit('change')"
                  ></el-input>
                </el-form-item>
              </template>
              <template v-if="item.componentType === 'select'">
                <el-form-item>
                  <el-select
                    v-model="item.componentValue"
                    :placeholder="item.componentPlace"
                    clearable
                    @change="$emit('change')"
                  >
                    <el-option
                      v-for="(v, index) in item.option"
                      :key="'v' + index"
                      :label="v.label"
                      :value="v.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.componentType === 'checkbox'">
                <el-form-item>
                  <el-select
                    v-model="item.componentValue"
                    multiple
                    clearable
                    popper-class="business-select-poper"
                    :placeholder="item.componentPlace"
                    @change="$emit('change')"
                  >
                    <div class="checkbox-in-select">
                      <el-checkbox
                        v-model="item.checkAll"
                        :indeterminate="item.componentValue.length > 0 && item.componentValue.length < item.option.length"
                        @change="checked => { handleCheckAll(checked, item) }"
                      >全选</el-checkbox>
                      <el-checkbox
                        v-model="item.checkReverse"
                        @change="checked => { handleCheckReverse(checked, item) }"
                      >反选</el-checkbox>
                    </div>
                    <el-option
                      v-for="item in item.option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.componentType === 'radio'">
                <el-form-item>
                  <el-radio
                    v-for="(r, index) in item.option"
                    :key="'r' + index"
                    v-model="item.componentValue"
                    :label="r.value"
                    @change="$emit('change')"
                    >{{ r.label }}</el-radio
                  >
                </el-form-item>
              </template>
              <template v-if="item.componentType === 'range'">
                <div class="form-flex-row">
                  <el-form-item
                    :prop="'businessSetting.' + index + '.minValue'"
                    :rules="rules.minValue">
                    <el-input v-model="item.minValue" :placeholder="JSON.parse(item.componentPlace)[0]" @change="$emit('change')"></el-input>
                  </el-form-item>
                  <span class="form-item-sep">~</span>
                  <el-form-item
                    :prop="'businessSetting.' + index + '.maxValue'"
                    :rules="rules.maxValue">
                    <el-input v-model="item.maxValue" :placeholder="JSON.parse(item.componentPlace)[1]" @change="$emit('change')"></el-input>
                  </el-form-item>
                </div>
              </template>
            </el-col>
          </el-row>
        </el-form-item>
      </div>
    </el-form>
    <el-dialog :visible.sync="showVidDialog" title="影片查询" width="75%" destroy-on-close>
      <VideoSearch @data-select="handleSelectVid" @close="showVidDialog = false" />
      <template slot="footer">
        <div></div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import VideoSearch from './VideoSearch.vue'
export default {
  components: {
    VideoSearch
  },
  data() {
    var checkComponentValue = (rule, value, callback) => {
      const index = rule.field
        .replace('businessSetting.', '')
        .replace('.componentValue', '')
      const item = this.form.businessSetting[index]
      const componentType = item.componentType
      if (componentType === 'text') {
        let info = this.handleCheck(item, value)
        if (info.code === 0) {
          callback()
        } else {
          callback(new Error(info.message))
        }
      } else {
        callback()
      }
    }
    var checkRangeValue = (rule, value, callback) => {
      const fields = rule.field.split('.')
      const item = this.form.businessSetting[fields[1]]
      const errorMsg = this.checkMinMaxValue(item, fields[2], value)
      if (errorMsg) {
        return callback(new Error(errorMsg))
      }
      callback()
    }
    return {
      index: 0,
      form: {
        businessSetting: []
      },
      vidComponent: null,
      showVidDialog: false,
      rules: {
        componentValue: [{ validator: checkComponentValue, trigger: 'blur' }],
        minValue: [{ validator: checkRangeValue, trigger: 'blur' }],
        maxValue: [{ validator: checkRangeValue, trigger: 'blur' }]
      }
    }
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    labelWidth: {
      type: String,
      default: '112px'
    }
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        this.handleBusiness()
      },
      deep: true
    }
  },
  methods: {
    handleCheck(obj, val) {
      const type = obj.componentReg.validationType
      const allowingList = obj.componentReg.allowing
      const message = obj.componentReg.help
      const required = obj.componentReg.optional === false || obj.componentReg.need === true
      const maxLength = obj.componentReg.maxLength
      const minLength = obj.componentReg.minLength
      const max = obj.componentReg.maxRange
      const min = obj.componentReg.minRange
      let status = { code: 0, message: '成功' }
      if (required && !val) {
        status = { code: -1, message: '必填' }
        return status
      }
      if (obj.componentReg.validator_length || obj.componentReg.validateLength) {
        if (val) {
          if (!(val.length >= minLength && val.length <= maxLength)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 类型校验
      // 数字 number
      if (type && type.indexOf('number') > -1) {
        if (val) {
          if (isNaN(val)) {
            status = { code: -1, message: message }
            return status
          }
          // 只有数字类型会校验大小
          if (!(parseFloat(val) >= min && parseFloat(val) <= max)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      let newValue = val
      if (allowingList) {
        // eslint-disable-next-line
        const charList = allowingList.replace('.', '\\\.')
        const reg = new RegExp('[' + charList + ']', 'g')
        newValue = val.replace(reg, '')
      }
      // 数字+字母 alphanumeric
      if (type && type.indexOf('alphanumeric') > -1) {
        if (newValue) {
          if (!/^[A-Za-z0-9]+$/.test(newValue)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 数字中文和字母 letternumeric
      if (type && type.indexOf('letternumeric') > -1) {
        if (newValue) {
          if (!/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(newValue)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 自定义 custom
      if (type && type.indexOf('custom') > -1) {
        const regexp = obj.componentReg.regexp || ''
        const regx = new RegExp(regexp)
        if (val) {
          if (!regx.test(val)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 日期 date
      if (type && type.indexOf('date') > -1) {
        if (val) {
          const format = obj.componentReg.format || 'yyyy-mm-dd'
          if (!this.parseDate(val, format)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 邮件 email
      if (type && type.indexOf('email') > -1) {
        if (val) {
          if (
            !/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
              val
            )
          ) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      // 网址
      if (type && type.indexOf('url') > -1) {
        if (val) {
          const strRegex =
            '^((https|http|ftp)://)?' + // (https或http或ftp):// 可有可无
            "(([\\w_!~*'()\\.&=+$%-]+: )?[\\w_!~*'()\\.&=+$%-]+@)?" + // ftp的user@  可有可无
            '(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
            '|' + // 允许IP和DOMAIN（域名）
            '(localhost)|' + // 匹配localhost
            "([\\w_!~*'()-]+\\.)*" + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
            '\\w+\\.' + // 一级域名 -英文或数字  加上.
            '[a-zA-Z]{1,6})' + // 顶级域名- 1-6位英文
            '(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
            '((/?)|' + // url无参数结尾 - 斜杆或这没有
            "(/[\\w_!~*'()\\.;?:@&=+$,%#-]+)+/?)$" // 请求参数结尾- 英文或数字和[]内的各种字符
          const urlFilter = new RegExp(strRegex, 'i') // i不区分大小写
          if (!urlFilter.test(val)) {
            status = { code: -1, message: message }
            return status
          }
        }
      }
      return status
    },
    checkMinMaxValue(item, field, value) {
      console.log('item, field, value===', item, field, value)
      if (!item.componentReg) {
        if (value && value.length > 128) {
          return '长度不能大于128个字符'
        }
        return ''
      }
      const itemReg = field === 'minValue' ? item.componentReg[0] : item.componentReg[1]
      const min = itemReg.minRange
      const max = itemReg.maxRange
      if (isNaN(value)) {
        return '请输入数字'
      }
      if (itemReg.need && value === '') {
        return '此项必填'
      }
      if (parseFloat(value) < min || parseFloat(value) > max) {
        return itemReg.help
      }
      if (field === 'maxValue' && item.minValue && parseFloat(value) < parseFloat(item.minValue)) {
        return '不能小于最小值'
      }
      return ''
    },
    parseDate(val, dateFormat) {
      let divider = dateFormat.replace(/[a-zA-Z]/gi, '').substring(0, 1)
      let regexp = '^'
      let formatParts = dateFormat.split(divider || null)
      let matches, day, month, year
      formatParts.forEach((item, i) => {
        regexp += (i > 0 ? '\\' + divider : '') + '(\\d{' + item.length + '})'
      })
      regexp += '$'
      matches = val.match(new RegExp(regexp))
      if (matches === null) {
        return false
      }
      var findDateUnit = function (unit, formatParts, matches) {
        for (var i = 0; i < formatParts.length; i++) {
          if (formatParts[i].substring(0, 1) === unit) {
            let val = matches[i + 1]
            if (val.indexOf('0') === 0) {
              val = val.replace('0', '')
            }
            return parseInt(val, 10)
          }
        }
        return -1
      }
      month = findDateUnit('m', formatParts, matches)
      day = findDateUnit('d', formatParts, matches)
      year = findDateUnit('y', formatParts, matches)
      if (
        (month === 2 &&
          day > 28 &&
          (year % 4 !== 0 || (year % 100 === 0 && year % 400 !== 0))) ||
        (month === 2 &&
          day > 29 &&
          (year % 4 === 0 || (year % 100 !== 0 && year % 400 === 0))) ||
        month > 12 ||
        month === 0
      ) {
        return false
      }
      if (
        (this.isShortMonth(month) && day > 30) ||
        (!this.isShortMonth(month) && day > 31) ||
        day === 0
      ) {
        return false
      }
      return [year, month, day]
    },
    isShortMonth(m) {
      return (m % 2 === 0 && m < 7) || (m % 2 !== 0 && m > 7)
    },
    parseDateInt(val) {
      if (val.indexOf('0') === 0) {
        val = val.replace('0', '')
      }
      return parseInt(val, 10)
    },
    handleBusiness() {
      let businessData = this.value
      if (Object.keys(this.value).length > 0) {
        let businessData = this.value
        for (let i in businessData) {
          const item = businessData[i]
          if (item.componentType === 'text') {
            if (
              item.componentReg.validationType &&
              item.componentReg.validationType.indexOf('number') !== -1
            ) {
              item.options = [
                {
                  label: '等于',
                  value: 'eq'
                },
                {
                  label: '不等于',
                  value: 'neq'
                },
                {
                  label: '大于',
                  value: 'gt'
                },
                {
                  label: '大于等于',
                  value: 'gte'
                },
                {
                  label: '小于',
                  value: 'lt'
                },
                {
                  label: '小于等于',
                  value: 'lte'
                }
              ]
            } else {
              item.options = [
                {
                  label: '包含',
                  value: 'in'
                },
                {
                  label: '不包含',
                  value: 'notin'
                }
              ]
            }
          } else if (item.componentType === 'select') {
            item.options = [
              {
                label: '等于',
                value: 'eq'
              },
              {
                label: '不等于',
                value: 'neq'
              }
            ]
          } else if (item.componentType === 'radio') {
            item.options = [
              {
                label: '等于',
                value: 'eq'
              },
              {
                label: '不等于',
                value: 'neq'
              }
            ]
          } else if (item.componentType === 'checkbox') {
            if (item.componentKey === 'cBrand') {
              // 处理自动选择飞利浦品牌
              // item.componentMatchType = item.componentMatchType
              //   ? item.componentMatchType
              //   : 'notin'
              item.options = [
                {
                  label: '不包含',
                  value: 'notin'
                },
                {
                  label: '包含',
                  value: 'in'
                }
              ]
            } else {
              // item.componentMatchType = item.componentMatchType
              //   ? item.componentMatchType
              //   : 'in'
              item.options = [
                {
                  label: '包含',
                  value: 'in'
                },
                {
                  label: '不包含',
                  value: 'notin'
                }
              ]
            }
          } else {
            item.options = [
              {
                label: '介于',
                value: 'in'
              }
            ]
          }
        }
      }
      this.form.businessSetting = businessData
    },
    // 打开影视id选择弹窗
    openSelectVid(item) {
      this.vidComponent = item
      this.showVidDialog = true
    },
    // 处理选择的vid
    handleSelectVid(data = []) {
      let vids = []
      if (this.vidComponent && this.vidComponent.componentValue) {
        vids = this.vidComponent.componentValue.split(',')
      }
      data.forEach(item => {
        if (!vids.includes(item.coocaaVId)) {
          vids.push(item.coocaaVId)
        }
        if (!vids.includes(item.thirdId)) {
          vids.push(item.thirdId)
        }
      })
      this.vidComponent.componentValue = vids.join(',')
      this.$emit('change')
    },
    handleCheckAll(checked, item) {
      if (checked) {
        item.componentValue = item.option.map(op => op.value)
      } else {
        item.componentValue = []
      }
      this.$emit('change')
    },
    handleCheckReverse(checked, item) {
      item.componentValue = item.option
        .filter(op => {
          return !(item.componentValue || []).includes(op.value)
        })
        .map(op => op.value)
      this.$emit('change')
    }
  },
  created() {
    this.handleBusiness()
  }
}
</script>

<style lang="stylus" scoped>
>>>.el-select
  width 100%
>>>.el-tag.el-tag--info
  background-color #fff3e6
  border-color #fff3e6
  color #ff8b00
>>>.el-tag.el-tag--info .el-tag__close
  color #ff8b00
  background none
.form-flex-row
  display flex
  .form-item-sep
    padding 0 4px
    line-height 30px
  .el-form-item
    flex-grow 1
.el-input >>> .el-input-group__append
  background-color #fff
  &:hover, &:focus
    color #FF8B00
    border-color #ffdcb3
    background-color #fff3e6
>>> .el-dialog__body
  padding 20px 30px 0
.checkbox-in-select
  position sticky
  padding 8px 18px
  top 0px
  text-align left
  background-color #fff
  z-index 999
</style>

<style lang="stylus">
.business-select-poper .el-select-dropdown__list
  padding-top 0
</style>
